/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
// 
import Input from "../input"
// 
import "./index.scss"
import moment from "moment"

const MaskedInput = ({
	placeholder,
	onBlur,
	mask,
	formats,
	onChange,
	initialValue,
	isReadOnly,
	value,
	...props
}) => {
	const [input, setInput] = useState({})
	const [cursor, setCursor] = useState(0)
	const [inputValue, setInputValue] = useState(null)

	useEffect(() => {
		setInput({ ...input })
		// setInput({ ...input })
	}, [])

	useEffect(() => {
		if (input) {
			input.selectionEnd = cursor
			input.selectionStart = cursor
		}
	}, [cursor, input])

	const onPressBackspace = (event) => {
		if (event.code === "Backspace") {
			const allNumbers = "0123456789"
			const { value } = event.target
			const charToEreaseIndex = event.target.selectionStart - 1
			const charToErease = value[charToEreaseIndex]

			if (!allNumbers.includes(charToErease)) {
				event.target.selectionEnd = charToEreaseIndex
				event.target.selectionStart = charToEreaseIndex
			}

			if (onChange) onChange(event.target.value || null)
		}

	}

	const customFormatter = (target) => {
		const cleanedValue =
			target.value !== undefined ? target.value.replace(/\D/g, "") : ""

		formats.some((item) => {
			if (item.condition(cleanedValue)) {
				let valueIndex = 0
				let finalValue = ""

				item.format.split("").forEach((char) => {
					if (char === "#") {
						finalValue += cleanedValue[valueIndex] || mask
						valueIndex += 1
					} else {
						finalValue += char
					}
				})
				setInput(target)
				setInputValue(finalValue)
				setCursor(finalValue.indexOf(mask))

				if (onChange) {
					if (item.format === "##/##/####") {
						onChange(moment(finalValue, "DD/MM/YYYY").format("YYYY-MM-DD HH:mm"))
					} else {
						onChange(finalValue)
					}
				}
				return true
			}
			return false
		})
	}

	return (
		<Input
			{...props}
			onKeyDown={onPressBackspace}
			value={inputValue || value}
			mask={mask}
			onInput={(event) => {
				customFormatter(event.target)
			}}
			isReadOnly={isReadOnly}
			placeholder={placeholder}
			onBlur={onBlur}
		/>
	)
}

MaskedInput.defaultProps = {
	placeholder: null,
	onBlur: () => { },
	onInput: () => { },
	onChange: null,
	isReadOnly: false,
	initialValue: "",
	mask: " ",
}

MaskedInput.propTypes = {
	initialValue: PropTypes.string,
	placeholder: PropTypes.string,
	mask: PropTypes.string,
	value: PropTypes.string,
	//
	isReadOnly: PropTypes.bool,
	//
	onBlur: PropTypes.func,
	onInput: PropTypes.func,
	onChange: PropTypes.func,
	//
	formats: PropTypes.arrayOf(
		PropTypes.shape({
			condition: PropTypes.func,
			format: PropTypes.string,
		})
	).isRequired,
}

export default MaskedInput
